"use strict";

/* Start of JS code for shop by shape 01-08-24*/
/* JS code for selecting the shape image ,changing the image and getting alt value of image*/
document.addEventListener('DOMContentLoaded', function () {
  var outerDivs = document.querySelectorAll('.iconwithtext');
  var activeDiv = null;
  function setActiveDiv(div) {
    if (activeDiv && activeDiv !== div) {
      var prevImageNew = activeDiv.querySelector('.image-new');
      var prevImageSecondActive = activeDiv.querySelector('.image-second.active');
      if (prevImageNew) {
        prevImageNew.style.display = "block";
      }
      if (prevImageSecondActive) {
        prevImageSecondActive.style.display = "none";
      }
    }
    activeDiv = div;
    var imageNew = div.querySelector('.image-new');
    var imageSecondActive = div.querySelector('.image-second.active');
    if (imageNew) {
      imageNew.style.display = "none";
    }
    if (imageSecondActive) {
      imageSecondActive.style.display = "block";
    }
    updateDisplayAreaAndLog(div);
  }
  function updateDisplayAreaAndLog(div) {
    var paragraph = div.querySelector('p');
    if (paragraph) {
      var paragraphText = paragraph.textContent;
      var displayArea = document.getElementById('displayArea');
      if (displayArea) {
        displayArea.textContent = paragraphText;
      }
    }
  }
  if (outerDivs.length > 0) {
    setActiveDiv(outerDivs[0]);
  }
  outerDivs.forEach(function (outerDiv) {
    outerDiv.addEventListener('mouseenter', function () {
      setActiveDiv(outerDiv);
    });
    outerDiv.addEventListener('mouseleave', function () {});
  });
});

/* JS code for selecting the color image ,changing the image and getting alt value of image*/
document.addEventListener('DOMContentLoaded', function () {
  var colorImages = document.querySelectorAll('.colorimage');
  var selectedImage = colorImages[2];
  selectedImage.classList.add('selected');
  displaySelectedAlt(selectedImage);
  function displaySelectedAlt() {
    var altText = selectedImage.getAttribute('alt');
    var displayArea = document.getElementById('displayArea2');
    if (displayArea) {
      displayArea.textContent = altText;
    }
  }
  colorImages.forEach(function (colorImage) {
    colorImage.addEventListener('mouseenter', function () {
      if (selectedImage !== colorImage) {
        selectedImage.classList.remove('selected');
        colorImage.classList.add('selected');
        selectedImage = colorImage;
        displaySelectedAlt();
      }
    });
    colorImage.addEventListener('mouseleave', function () {});
  });
});

/* JS code for selecting the carat image and getting alt value of image and hover on platinum not able to select carat*/

document.addEventListener('DOMContentLoaded', function () {
  var caratImages = document.querySelectorAll('.carat-image');
  var selectedImage = caratImages[0];
  selectedImage.classList.add('selected');
  var displayArea3 = document.getElementById('displayArea3');
  var displayArea2 = document.getElementById('displayArea2');
  function displaySelectedAlt() {
    if (displayArea3 && selectedImage) {
      var altText = selectedImage.getAttribute('alt');
      displayArea3.textContent = altText;
    } else if (displayArea3) {
      displayArea3.textContent = '14K';
    }
  }
  function resetSelection() {
    if (selectedImage) {
      selectedImage.classList.remove('selected');
      selectedImage.style.opacity = '1';
    }
    selectedImage = null;
    displaySelectedAlt();
  }
  function handleHover(caratImage) {
    if (displayArea2 && displayArea2.textContent.trim() === 'platinum') {
      resetSelection();
      caratImages.forEach(function (image) {
        return image.style.opacity = '0.5';
      });
      return;
    }
    if (selectedImage !== caratImage) {
      if (selectedImage) {
        selectedImage.classList.remove('selected');
        selectedImage.style.opacity = '1';
      }
      caratImage.classList.add('selected');
      caratImage.style.opacity = '1';
      selectedImage = caratImage;
      displaySelectedAlt();
    }
  }
  displaySelectedAlt();
  caratImages.forEach(function (caratImage) {
    caratImage.addEventListener('mouseenter', function () {
      return handleHover(caratImage);
    });
    caratImage.addEventListener('mouseleave', function () {});
  });
  var observer = new MutationObserver(function () {
    if (displayArea2 && displayArea2.textContent.trim() === 'platinum') {
      resetSelection();
      caratImages.forEach(function (image) {
        return image.style.opacity = '0.5';
      });
    } else {
      if (!selectedImage) {
        selectedImage = caratImages[0];
        selectedImage.classList.add('selected');
        selectedImage.style.opacity = '1';
      }
      caratImages.forEach(function (image) {
        return image.style.opacity = '1';
      });
    }
  });
  if (displayArea2) {
    observer.observe(displayArea2, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
});

/* JS code for changing the image url*/
document.addEventListener('DOMContentLoaded', function () {
  var displayArea = document.getElementById('displayArea');
  var displayArea2 = document.getElementById('displayArea2');
  var displayArea3 = document.getElementById('displayArea3');
  var combineImage = document.querySelector('.combine-image');
  function updateImageSrc() {
    var value1 = displayArea ? displayArea.textContent.trim() : '';
    var value2 = displayArea2 ? displayArea2.textContent.trim() : '';
    var value3 = displayArea3 ? displayArea3.textContent.trim() : '';
    var newSrcValue = "".concat(value1, "_").concat(value2, ".png");
    newSrcValue = "https://cdn.shopify.com/s/files/1/0611/2185/5655/files/".concat(newSrcValue);
    if (combineImage) {
      combineImage.src = newSrcValue;
    }
  }
  function setupMutationObserver(targetNode, callback) {
    var observer = new MutationObserver(callback);
    observer.observe(targetNode, {
      childList: true,
      subtree: true,
      characterData: true
    });
    return observer;
  }
  updateImageSrc();
  var observerCallback = function observerCallback() {
    updateImageSrc();
  };
  if (displayArea) setupMutationObserver(displayArea, observerCallback);
  if (displayArea2) setupMutationObserver(displayArea2, observerCallback);
  if (displayArea3) setupMutationObserver(displayArea3, observerCallback);
});
document.addEventListener('DOMContentLoaded', function () {
  var displayArea = document.getElementById('displayArea');
  var button = document.querySelector('.button-to-explore');
  var displayArea2 = document.getElementById('displayArea2');
  var displayArea3 = document.getElementById('displayArea3');
  function updateButtonLink() {
    var value1 = displayArea ? displayArea.textContent.trim() : '';
    var value2 = displayArea2 ? displayArea2.textContent.trim() : '';
    var value3 = displayArea3 ? displayArea3.textContent.trim() : '';
    var words = value2.split('-');
    var formattedStr = words.map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join('+');
    if (button) {
      if (formattedStr == "Platinum") {
        button.addEventListener('click', function () {
          window.location.href = "https://www.diamondchemistry.com/collections/".concat(value1, "-engagement-rings?filter.v.option.metal=").concat(formattedStr);
        });
      } else {
        button.addEventListener('click', function () {
          window.location.href = "https://www.diamondchemistry.com/collections/".concat(value1, "-engagement-rings?filter.v.option.metal=").concat(value3, "+").concat(formattedStr);
        });
      }
    }
  }
  updateButtonLink();
  if (displayArea) {
    var observer = new MutationObserver(function () {
      updateButtonLink();
    });
    observer.observe(displayArea, {
      childList: true,
      subtree: true,
      characterData: true
    });
    observer.observe(displayArea2, {
      childList: true,
      subtree: true,
      characterData: true
    });
    observer.observe(displayArea3, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
});

/* End of JS code for shop by shape 01-08-24*/

/* Start of JS code for see it love it 08-08-24*/
document.addEventListener("DOMContentLoaded", function () {
  var currentScrollPos = window.scrollY;
  document.querySelectorAll('.circle-button').forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      var sectionNumber = this.getAttribute('data-section');
      currentScrollPos = window.scrollY;
      if (!this.classList.contains('active')) {
        document.querySelectorAll('.shoppable-feature').forEach(function (section) {
          section.style.display = 'none';
        });
        var selectedSection = document.querySelector('.shoppable-' + sectionNumber);
        selectedSection.style.display = 'block';
        document.querySelectorAll('.circle-button').forEach(function (btn) {
          btn.classList.remove('active');
        });
        this.classList.add('active');
        window.scrollTo(0, currentScrollPos);
      }
    });
  });
});

/* End of JS code for see it love it 08-08-24*/

// Js for chaning for shop by category

document.querySelectorAll('.collection-item__title').forEach(function (element) {
  var text = element.textContent.trim();
  element.textContent = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
});

// End of js chages for shop by category